module.exports = __webpack_public_path__ + "img/02d.46bc0738.svg";